module.exports = __webpack_public_path__ + "static/media/Logo_SOK.17cdbe7f.png";